// helpers/bcCouponHelper.js
export function isSameCouponCriteria(firstCriteria, secondCriteria) {
  return firstCriteria?.categoryCode === secondCriteria?.categoryCode &&
         firstCriteria?.couponType === secondCriteria?.couponType &&
         firstCriteria?.hotDeals === secondCriteria?.hotDeals;
}
